// extracted by mini-css-extract-plugin
module.exports = {"sensor":"SensorsFormField_sensor__1YpxV"};